export class SuitabilityProfileModel {
    profile: number;
    description: string;
    isExpired: boolean;
}
